import React, { Component } from "react";
import { observer } from "mobx-react";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import InfiniteScroll from "react-infinite-scroll-component";
import paginationFactory from "react-bootstrap-table2-paginator";
import { Col, Row } from "reactstrap";
import { buscaFiltrarVazio } from '../../../../utils/mensagens';
import { HeaderTableFixed } from "../../../../utils/headerTableFixed";
import LoadingImage from "../../../comum/components/LoadingImage";

@observer
export class TabelaSailingBreakdown extends Component {
    constructor(props) {
        super(props);
        this.controller = this.props.controller;
        window.addEventListener('scroll', HeaderTableFixed)
    }

    render() {
        if(this.controller.loading) {
            return (
                <Row>
                    <Col className="mt-3">
                        <LoadingImage />
                    </Col>
                </Row>
            )
        }else{
            return (
                !this.controller.filtrado
                    ? <Row>
                        <Col className="mt-3" xs={12}>
                            <span className="mensagem-filtrar">
                                {buscaFiltrarVazio}
                            </span>
                        </Col>
                    </Row>
                    : 
                    <InfiniteScroll
                        dataLength={this.controller.itens.length}
                        next={this.controller.loadNextTurn}
                        hasMore={this.controller.hasMore}
                        loader={<LoadingImage />}
                    >
                        <ToolkitProvider
                            keyField="NavioNome"
                            data={[...this.controller.itens]}
                            columns={[...this.controller.colunas]}>
                            {props => (
                                <div id="tableHeaderFixed">
                                    <BootstrapTable bootstrap4
                                        striped
                                        bordered={false}
                                        noDataIndication={() => this.controller.loading ?
                                            <LoadingImage /> : this.controller.tableMessage}
                                        classes="tabela"
                                        //pagination={paginationFactory()}
                                        {...props.baseProps} />
                                </div>)}
                        </ToolkitProvider>
                    </InfiniteScroll>
    
            )
        }
    }
}


// WEBPACK FOOTER //
// ./src/modules/consultas/sailing-breakdown/components/TabelaSailingBreakdown.js